import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { TextFieldModule } from '@angular/cdk/text-field';

@NgModule({
  imports: [
  CommonModule,
  MatCardModule,
  MatFormFieldModule,
  MatIconModule,
  MatDividerModule,
  MatBadgeModule,
  MatChipsModule,
  MatListModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatInputModule,
  MatMenuModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatGridListModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatRadioModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatSliderModule,
  MatToolbarModule,
  MatTabsModule,
  MatExpansionModule,
  TextFieldModule
  ],
  exports: [
  MatCardModule,
  MatFormFieldModule,
  MatIconModule,
  MatDividerModule,
  MatBadgeModule,
  MatChipsModule,
  MatListModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatInputModule,
  MatMenuModule,
  MatSnackBarModule,
  MatSlideToggleModule,
  MatGridListModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatRadioModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatSliderModule,
  MatToolbarModule,
  MatTabsModule,
  MatExpansionModule,
  TextFieldModule
  ],
  declarations: []
  })
export class AppMaterialModule {
}
